import { COUNTRIES } from '@config/constants'

export const GDPR_SETTINGS_ANCHOR = 'settings'

export const COOKIES_TRACKING_PREFIX = 'CMP'

export const COOKIES_TRACKING_NAME = {
  ACCEPT: 'accept',
  BANNER: 'v1',
  BACK: 'back',
  DATA_PROTECTION: 'data_protection',
  INFO: 'more_information',
  LEGAL_MENTIONS: 'legal_mentions',
  MODAL: 'v2',
  MODAL_STEP: 'step',
  REFUSE: 'refuse',
  SAVE: 'save_settings',
  SETTINGS: 'settings',
  TOGGLE: 'toggle',
}

export const COUNTRIES_WITHOUT_MODAL = [COUNTRIES.US]
